import { animate } from "motion/react";
import { useRef, useEffect } from "react";

function AnimatedNumber({ value, inView }: { value: string; inView: boolean }) {
  const nodeRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const node = nodeRef.current;
    if (!node || !inView) return;

    // Parser la valeur
    const match = value.match(/([+-]?\d+(?:\.\d+)?)(.*)/);
    if (!match) {
      node.textContent = value;
      return;
    }

    const [, numStr, suffix] = match;
    const targetValue = parseFloat(numStr);
    const isNegative = value.startsWith("-");
    const isPositive = value.startsWith("+");
    const prefix = isNegative ? "-" : isPositive ? "+" : "";

    const controls = animate(0, Math.abs(targetValue), {
      duration: 2,
      ease: "easeOut",
      onUpdate(latest) {
        const decimals = suffix === "/5" ? 1 : 0;
        const formatted = latest.toFixed(decimals);
        node.textContent = `${prefix}${formatted}${suffix}`;
      },
    });

    return () => controls.stop();
  }, [inView, value]);

  return <span ref={nodeRef}>0</span>;
}

export default AnimatedNumber;
